import api from './api'

const resource = '/ratings/'

export default {
    get(page, region, branch, outlet, start, end, position, q) {
        return api.get(`/ratings?page=${page}&region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&position=${position}&q=${q}`);
    },
    excel(region, branch, outlet, start, end, position, q) {
        return api.get(`/ratings/export?per_page=1000&region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&position=${position}&q=${q}`, {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/vnd.ms-excel'
            }});
    },
    detail(id) {
        return api.get(`/ratings/${id}/detail`, {
            responseType: 'arraybuffer',
            headers: {
              'Accept': 'application/pdf'
            }}
        );
    },
    delete(id) {
        return api.delete(`/ratings/${id}`);
    },
    getTop() {
        return api.get(`/ratings/top`);
    },
    getActive(region='', branch='', outlet='', start, end, facility='', position='', author='', author_id='') {
        if(region!='' && region!=999999){
            if(branch!='' && branch!=999999){
                if(outlet!='' && outlet!=999999){
                    return api.get(`${resource}active?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
                } else {
                    return api.get(`${resource}active?region=${region}&branch=${branch}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
                }
            } else {
                return api.get(`${resource}active?region=${region}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
            }
        } else {
            return api.get(`${resource}active?start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
        }
    },
    getScore(region='', branch='', outlet='', start, end, facility='', position='', author='', author_id='') {
        if(region!='' && region!=999999){
            if(branch!='' && branch!=999999){
                if(outlet!='' && outlet!=999999){
                    return api.get(`${resource}score?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
                } else {
                    return api.get(`${resource}score?region=${region}&branch=${branch}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
                }
            } else {
                return api.get(`${resource}score?region=${region}&start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
            }
        } else {
            return api.get(`${resource}score?start=${start}&end=${end}&facility=${facility}&position=${position}&author=${author}&author_id=${author_id}`);
        }
    },
    getReport(region='', branch='', outlet='', start, end, facility='') {
        if(region!='' && region!=999999){
            if(branch!='' && branch!=999999){
                if(outlet!='' && outlet!=999999){
                    return api.get(`${resource}?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}&facility=${facility}`);
                } else {
                    return api.get(`${resource}?region=${region}&branch=${branch}&start=${start}&end=${end}`);
                }
            } else {
                return api.get(`${resource}?region=${region}&start=${start}&end=${end}`);
            }
        } else {
            return api.get(`${resource}?start=${start}&end=${end}`);
        }
        
    },
    general() {
        return api.get(`/ratings/general`);
    },
    getDetail(npp, start, end, facility='') {
        return api.get(`/ratings/detail/${npp}?start=${start}&end=${end}&facility=${facility}`);
    },
    getByCategory(region, branch, outlet, start, end) {
        return api.get(`/ratings/category?region=${region}&branch=${branch}&outlet=${outlet}&start=${start}&end=${end}`);
    }
}